module.exports = __webpack_public_path__ + "img/banner.32a12f8e.png";